import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

const payoutMethodLabel = (p) => {
  if (!p) return 'Not set';
  if (p.stripe_connect_status === 'active') return 'Bank Account (auto via Stripe)';
  const m = p.payout_method || p.preferred_payment_method;
  if (m === 'paypal') return `PayPal (${p.paypal_email || 'not set'})`;
  if (m === 'zelle') return `Zelle (${p.zelle_email || p.zelle_phone || 'not set'})`;
  if (m === 'bank_transfer') return `Bank Transfer (${p.bank_name || 'not set'})`;
  if (m === 'stripe' || m === 'stripe_connect') return 'Stripe Connect';
  return 'Not set';
};

export function WithdrawDialog({ open, onOpenChange, profile, withdrawAmount, setWithdrawAmount, handleWithdraw, withdrawing }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-[#262626]">
        <DialogHeader>
          <DialogTitle>Withdraw Funds</DialogTitle>
          <DialogDescription>Enter the amount you want to withdraw</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="p-4 bg-surface-highlight rounded-lg">
            <p className="text-sm text-[#A1A1AA]">Available Balance</p>
            <p className="text-2xl font-mono font-bold text-lime">${(profile?.available_balance || 0).toFixed(2)}</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="withdraw-amount">Amount (USD)</Label>
            <Input id="withdraw-amount" type="number" step="0.01" min="0" max={profile?.available_balance || 0} value={withdrawAmount} onChange={(e) => setWithdrawAmount(e.target.value)} className="input-dark" placeholder="Enter amount" data-testid="withdraw-amount-input" />
          </div>
          <div className="p-4 bg-surface-highlight rounded-lg">
            <p className="text-sm text-[#A1A1AA]">Payout Method</p>
            <p className="font-medium">{payoutMethodLabel(profile)}</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-[#262626]">Cancel</Button>
          <Button onClick={handleWithdraw} disabled={withdrawing || !withdrawAmount} className="btn-primary" data-testid="confirm-withdraw-btn">
            {withdrawing ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Request Withdrawal
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
